import { useNavigate } from "@tanstack/react-router";
import { BookOpen, FileText, Home, MessageSquare, Search, Settings, Upload } from "lucide-react";
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
  CommandShortcut,
} from "../../components/ui/command";
import { Dialog, DialogContent, DialogTitle } from "../../components/ui/dialog";
import { useUI } from "../../stores/ui";

interface CommandPaletteProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function CommandPalette({ open, onOpenChange }: CommandPaletteProps) {
  const nav = useNavigate();
  const cycleTheme = useUI((s) => s.cycleTheme);

  function go(to: string) {
    onOpenChange(false);
    void nav({ to });
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="overflow-hidden p-0 max-w-2xl">
        <DialogTitle className="sr-only">Paleta de comandos</DialogTitle>
        <Command>
          <CommandInput placeholder="Buscar docs, secciones, acciones…" />
          <CommandList>
            <CommandEmpty>Sin resultados.</CommandEmpty>
            <CommandGroup heading="Navegar">
              <CommandItem onSelect={() => go("/")}>
                <Home size={14} /> Inicio
                <CommandShortcut>g h</CommandShortcut>
              </CommandItem>
              <CommandItem onSelect={() => go("/docs")}>
                <FileText size={14} /> Documentos
                <CommandShortcut>g d</CommandShortcut>
              </CommandItem>
              <CommandItem onSelect={() => go("/search")}>
                <Search size={14} /> Buscar
                <CommandShortcut>g s</CommandShortcut>
              </CommandItem>
              <CommandItem onSelect={() => go("/chat")}>
                <MessageSquare size={14} /> Chat
                <CommandShortcut>g c</CommandShortcut>
              </CommandItem>
              <CommandItem onSelect={() => go("/notebooks")}>
                <BookOpen size={14} /> Mis apuntes
                <CommandShortcut>g n</CommandShortcut>
              </CommandItem>
              <CommandItem onSelect={() => go("/upload")}>
                <Upload size={14} /> Importar
                <CommandShortcut>g u</CommandShortcut>
              </CommandItem>
            </CommandGroup>
            <CommandGroup heading="Acciones">
              <CommandItem
                onSelect={() => {
                  cycleTheme();
                  onOpenChange(false);
                }}
              >
                <Settings size={14} /> Cambiar tema
                <CommandShortcut>⌘.</CommandShortcut>
              </CommandItem>
              <CommandItem onSelect={() => go("/settings")}>
                <Settings size={14} /> Ajustes
              </CommandItem>
            </CommandGroup>
          </CommandList>
        </Command>
      </DialogContent>
    </Dialog>
  );
}
